import React, { Component } from "react";
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';

import axios from '../../../axios';
import apiError from '../../../error';
import Spinner from '../../../component/spinner/spinner';
export default class CreateUsers extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            lastname: '',
            firstname: '',
            emailError: false,
            buttonLoading: false,
            firstnameError: false,
            roleIdError: false, 
            roles: [],
            roleId: null
        }
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            if (this.props.userId && this.props.userId > 0) {
                this.load();
            } else {
                this.setState({
                    email: '',
                    lastname: '',
                    firstname: '',
                    roleId: '',
                    emailError: false,
                    firstnameError: false,
                    roleIdError: false,
                });
                this.loadRole();
            }
        }
    }

    load = () => {
        if(this.props.userId && this.props.userId > 0){
            axios.get('/api/iam-user/'+this.props.userId, {})
            .then(res => {
                let roleId = res?.data?.employee?.userPolicies?.[0]?.role?.id
                this.setState({
                    email: res?.data?.employee?.email,
                    lastname: res?.data?.employee?.lastname,
                    firstname: res?.data?.employee?.firstname,
                    roleId
                })
            })
            .catch(err => apiError(err));
        }
        this.loadRole();
    }
    loadRole = () => {
        axios.get('/api/roles', {})
        .then(res => {
            this.setState({ roles: res.data.roles })
        })
        .catch(err => apiError(err));
    }

    handleResetPassword = () => {
        axios.post('/api/iam-user/resetPassword/', {
            userId: this.props.userId
        })
        .then(res => {
            this.props.handleModal();
            toast.success("Reset Password Link Has Been Sent To Emaployee Email Id");
        })
        .catch(err => apiError(err));
    }

    createUser = () => {
        if(this.state.firstname.length === 0 || (this.state.firstname).trim().length === 0){
            toast.error("Please Enter First Name");
            this.setState({firstnameError: true})
            return false;
        } else if(this.state.email.length === 0){
            toast.error("Please Enter Email Id");
            this.setState({emailError: true})
            return false;
        }
        else if(!this.state.roleId || this.state.roleId === "") {
            toast.error("Please select the Role from the drop-down");
            this.setState({roleIdError: true})
            return false;
        }
        
        this.setState({buttonLoading: true})

        // Prepare data
        const payload = {
            firstname: (this.state.firstname).trim(),
            lastname: (this.state.lastname).trim(),
            email: this.state.email,
            roleId: this.state.roleId,
        };

        if(this.props.userId && this.props.userId > 0){
            // Update existing user
            axios.patch('/api/iam-user/addEmployee/'+this.props.userId, payload)
            .then(res => {
                this.setState({
                    email: '',
                    lastname: '',
                    firstname: '',
                    roleId: '',
                    buttonLoading: false,
                })
                toast.success("User Updated Successfully");
                this.props.handleModal();
            })
            .catch(err => {
                this.setState({buttonLoading: false})
                apiError(err)
            });
        } else {
            // Create new user
            axios.post('/api/iam-user/addEmployee', payload)
            .then(res => {
                this.setState({
                    email: '',
                    lastname: '',
                    firstname: '',
                    roleId: '',
                    buttonLoading: false,
                })
                this.props.load();
                this.props.handleModal();
                toast.success("User Added Successfully");
            })
            .catch(err => {
                this.setState({buttonLoading: false})
                apiError(err)
            });
        }
    }

    render() {
        return (
            <Modal show={this.props.show} className="chooseModal commonModal info-filter right mainfooterModal right-modal-wrap" onHide={() => this.props.handleModal()} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <div id="example-custom-modal-styling-title">
                        <h5>{this.props.userId && this.props.userId > 0 ? "Update User Role" : "Add IAM User"}</h5>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Form.Group>
                            <Form.Label>First Name<span className="red-star">*</span></Form.Label>
                            <Form.Control type="text" disabled={this.props.userId && this.props.userId > 0} placeholder="Enter first name" isInvalid={this.state.firstnameError} value={this.state.firstname} onChange={e => this.setState({firstname: e.target.value, firstnameError: false})} />
                        </Form.Group>
                    </div>
                    <div>
                        <Form.Group>
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control type="text" disabled={this.props.userId && this.props.userId > 0} placeholder="Enter last name" value={this.state.lastname} onChange={e => this.setState({lastname: e.target.value})}/>
                        </Form.Group>
                    </div>
                    <div>
                        <Form.Group>
                            <Form.Label>Email Id<span className="red-star">*</span></Form.Label>
                            <Form.Control type="email" disabled={this.props.userId && this.props.userId > 0} placeholder="Enter email id" value={this.state.email} onChange={e => this.setState({email: e.target.value, emailError: false})}/>
                        </Form.Group>
                    </div>
                    {/* NEW: Role dropdown */}
                    <div>
                        <Form.Group>
                            <Form.Label>Select Role<span className="red-star">*</span></Form.Label>
                            <Form.Control
                                as="select"
                                value={this.state.roleId}
                                onChange={e => this.setState({ roleId: e.target.value, roleIdError: false })}
                                isInvalid={this.state.roleIdError}
                            >
                                <option value="">Select Role</option>
                                {this.state.roles.map(role => (
                                    <option key={role.id} value={role.id}>
                                        {role.name}
                                    </option>
                                ))}

                            </Form.Control>
                        </Form.Group>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Link to="#">
                        <Button variant="secondary" className="mr-2" onClick={this.props.handleModal}> Close </Button>
                        {this.props.userId && this.props.userId > 0 ?
                            <Button className='btn btn-success' onClick={this.createUser} disabled={this.state.buttonLoading}>
                                <Spinner loading={this.state.buttonLoading}></Spinner>
                                Update User
                            </Button> :
                            <Button className='btn btn-success' onClick={this.createUser} disabled={this.state.buttonLoading}>
                                <Spinner loading={this.state.buttonLoading}></Spinner>
                                Add User
                            </Button>
                        }
                    </Link>
                </Modal.Footer>
            </Modal>
        );
    }
}
